var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_1515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9966 8.81846 22.7312 5.76821 20.4815 3.51852C18.2318 1.26883 15.1815 0.00344108 12 0V0ZM20.941 11H17.463C17.2362 8.39489 16.4558 5.86823 15.174 3.589C16.7235 4.17499 18.0815 5.17671 19.0989 6.48411C20.1163 7.79151 20.7537 9.35402 20.941 11ZM9.68501 14H14.315C13.9213 16.0948 13.1359 18.0964 12 19.9C10.864 18.0965 10.0786 16.0948 9.68501 14ZM9.55301 11C9.83307 8.54378 10.67 6.18386 12 4.1C13.3302 6.18379 14.1671 8.54374 14.447 11H9.55301ZM8.82601 3.589C7.54417 5.86823 6.76377 8.39489 6.53701 11H3.05901C3.24635 9.35402 3.88372 7.79151 4.9011 6.48411C5.91847 5.17671 7.2765 4.17499 8.82601 3.589ZM3.23201 14H6.64101C6.97749 16.2511 7.7177 18.423 8.82601 20.411C7.43814 19.885 6.20149 19.0248 5.22569 17.9064C4.24989 16.7881 3.56509 15.4463 3.23201 14ZM15.174 20.411C16.2828 18.4231 17.023 16.2512 17.359 14H20.768C20.4349 15.4463 19.7501 16.7881 18.7743 17.9064C17.7985 19.0248 16.5619 19.885 15.174 20.411Z",
    fill: "#182444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_1515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.ed608d8cdc63db73f13ef7490cefa0a7.svg";
export { ForwardRef as ReactComponent };